import styles from './staticValue.module.css'
import { EmptyImgImg } from "../../constants"
import { TableName } from "../../../../tables"
import { useDataTypesHooks } from "../../../data-types"
import { FieldType, FieldValue } from "../types"
import { liveUrl } from '../../utils/uiUtils'
import { Async } from '../async-components/async/async'

type Props = {
    type: FieldType
    table?: TableName
    value?: FieldValue
    bold?: boolean
}

export const StaticValue = (props: Props) => {
    const { type, table, value, bold } = props
    const { formatTable, formatValue } = useDataTypesHooks()

    return <Async
        loadFn={async () => {
            if (type === FieldType.TABLE) {
                return <>{await formatTable(table!, value! as string)}</>
            } else if (type === FieldType.IMAGE) {
                const imgSrc = value ? liveUrl(value as string) : EmptyImgImg
                return <img src={imgSrc} alt={`${table} image.`} className={styles.img} />
            }
            const formattedValue = formatValue(value, type)
            
            return bold ?
                <strong>{formattedValue}</strong> :
                <>{formattedValue}</>
        }}
        deps={[type, table, value]}
    />
}
